import React from 'react';
import { BoldLabel } from '../../../styles/typography';

const CollapsedAdvancedOptions = () => <BoldLabel>Advanced Options</BoldLabel>;

CollapsedAdvancedOptions.displayName = 'CollapsedAdvancedOptions';

export default CollapsedAdvancedOptions;
